import { Link } from "react-router-dom";

import {
  FaInstagram,
  FaWhatsapp,
  FaMapMarkerAlt
} from "react-icons/fa";

import "./Footer.css";


function Footer() {

  return (

    <footer className="footer">

      <div className="footer-container">


        {/* ABOUT */}

        <div className="footer-box">

          <h2 className="logo">
            CUTIES 🤍
          </h2>

          <p>
            Cute clothes & essentials for your little ones.
            Made with love for every baby moment.
          </p>

        </div>


        {/* QUICK LINKS */}

        <div className="footer-box">

          <h3>
            Quick Links
          </h3>

          <Link to="/">
            Home
          </Link>

          <Link to="/shop">
            Shop
          </Link>

          <Link to="/cart">
            Cart
          </Link>

          <Link to="/contact">
            Contact
          </Link>

        </div>


        {/* CATEGORIES */}

        <div className="footer-box">

          <h3>
            Categories
          </h3>

          <Link to="/category/Baby">
            Baby
          </Link>

          <Link to="/category/Girls">
            Girls
          </Link>

          <Link to="/category/Boy">
            Boy
          </Link>

          <Link to="/category/Baby/Accessories">
            Accessories
          </Link>

          <Link to="/category/Toys">
            Toys
          </Link>

          <Link to="/category/Gifts">
            Gifts
          </Link>

          <Link to="/category/Nursery">
            Nursery
          </Link>

          <Link to="/category/Back to School">
            Back to School
          </Link>

        </div>


        {/* SOCIAL */}

        <div className="footer-box">

          <h3>
            Follow Us
          </h3>


          <div className="social">


            <a
              href="https://www.instagram.com/cuties_leb?igsh=bmVtOWozZzNkMGRv&utm_source=qr"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>


            <a
              href="https://wa.me/96179427021"
              target="_blank"
              rel="noreferrer"
              aria-label="WhatsApp"
            >
              <FaWhatsapp />
            </a>


            <a
              href="https://goo.gl/maps/iVMxAF7smbYbq1VM7"
              target="_blank"
              rel="noreferrer"
              aria-label="Location"
            >
              <FaMapMarkerAlt />
            </a>


          </div>


          <p>
            Email:
            <br />
            Cuties2026@gmail.com
          </p>

        </div>


      </div>


      {/* COPYRIGHT */}

      <div className="copyright">

        <p>
          © 2026 CUTIES. All Rights Reserved 🤍
        </p>


        <p className="lunora-credit">

          Website designed & developed by{" "}

          <a
            href="https://www.instagram.com/lunoraweb"
            target="_blank"
            rel="noreferrer"
          >
            Lunora Web
          </a>

          🤎

        </p>

      </div>


    </footer>

  );

}


export default Footer;